import { gql } from '@apollo/client';
import { Suspense, lazy } from 'react';

import { LoadingImage } from 'component-lib/atoms/LoadingImage/LoadingImage';
import { ChallengeTabType, TabContentChallengeChallengeTabFragment } from 'types/graphql';

import { Service } from './Service';

const Editor = lazy(() => import('play/legacy/editor'));

gql`
  fragment TabContentChallengeChallengeTab on ChallengeTab {
    id
    type
    target
    path
    new_window
  }
`;

export interface TabContentChallengeProps {
  isPreview?: boolean;
  tab: TabContentChallengeChallengeTabFragment;
  active: boolean;
  captureFocusOnServiceTabs?: boolean;
  isResizing?: boolean;
  useNewTerminal?: boolean;
}

export const TabContentChallenge = ({
  isPreview,
  tab,
  active,
  captureFocusOnServiceTabs = false,
  isResizing = false,
  useNewTerminal = false,
}: TabContentChallengeProps) =>
  tab.type === ChallengeTabType.Code ? (
    <Suspense fallback={<LoadingImage />}>
      <Editor active={active} baseURL={tab.target} root={tab.path} isPreview={isPreview} className="instruqt-test" />
    </Suspense>
  ) : (
    <Service
      isPreview={isPreview}
      active={active}
      type={tab.type}
      serviceID={`challenge-frame-${tab.id}`}
      url={tab.target}
      newWindow={tab.new_window || tab.type === ChallengeTabType.External}
      tabID={tab.id}
      captureFocus={captureFocusOnServiceTabs}
      isResizing={isResizing}
      useNewTerminal={useNewTerminal}
    />
  );
